module.exports = __webpack_public_path__ + "assets/img/146.2c035d13.png";